export default __webpack_public_path__ + "static/media/misc-drawerB-1920w.8c69287a.webp";